import ReactJson from "react-json-view";
import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import {
    fetchBenefitPlanTableScan, fetchHrpTableItemsByHccID, fetchBenefitPlanTableItemsByPk, fetchHrpTableItemsBySk, fetchHrpTableItemsBySparse, fetchHrpTableScan, fetchItemsByRetryOn, fetchNotificationsJobRegistryTableItemsByPk,
    fetchNotificationsJobRegistryTableScan
} from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { queryClient } from "../../App";
import DatePicker from "react-datepicker";
import ToggleSwitch from "../shared/ToggleSwitch";
import { getTimeDiff } from "../../utils/commonUtils";
import Select from 'react-select';

const searchOptions = [
    { value: 'jobName', label: 'Job name', additional: { pkKey: 'pk', skKey: 'sk' } },
    { value: 'invertedIndex', label: 'invertedIndex', additional: { pkKey: 'sk', skKey: 'pk' } },
    { value: 'sparseIndex', label: 'sparseIndex', additional: { pkKey: 'sparse', skKey: 'pk' } }
]

const sparseOptions = {
    STARTED: 'STARTED',
    COMPLETED: 'COMPLETED',
    ERROR: "ERROR",
    PENDING: "PENDING",
    ACTION_REQURED: "ACTION_REQURED",
    RUNNING: 'RUNNING',
}

const NotificationsJobRegistry = ({ subscriptionHccId, autoRefreshEnabled: parentAutoRefreshEnabled }) => {

    const now = new Date()

    const timezoneOffsetMs = now.getTimezoneOffset() * 60000;
    const localStartOfDayNow = new Date(now.getTime() - timezoneOffsetMs);
    localStartOfDayNow.setHours(0, 0, 0, 0);
    const [showMoreColumns, setShowMoreColumns] = useState(false);


    const [selectedSearchOption, setSelectedSearchOption] = useState(null);
    const [searchPkValue, setSearchPkValue] = useState();
    const [decouncedSearchPkValue, setDecouncedSearchPkValue] = useState();

    const [searchSkValue, setSearchSkValue] = useState();
    const [decouncedSearchSkValue, setDecouncedSearchSkValue] = useState();

    const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(parentAutoRefreshEnabled)

    const [selectedDate, setSelectedDate] = useState();

    useEffect(() => {
        setAutoRefreshEnabled(parentAutoRefreshEnabled)

    }, [parentAutoRefreshEnabled])

    useEffect(() => {
        if (subscriptionHccId) {
            setSelectedSearchOption({ value: 'hccId', label: 'hccId' })
            setSearchPkValue(subscriptionHccId)
            setDecouncedSearchPkValue(subscriptionHccId)
        }

    }, [subscriptionHccId])

    const { ref, inView } = useInView();

    const queryKey = ['notification-job-registry-table', selectedDate, selectedSearchOption?.value, decouncedSearchPkValue, decouncedSearchSkValue];

    const {
        data,
        refetch,
        fetchNextPage,
        fetchPreviousPage,
        isLoading, //first time only
        isFetching,
        hasNextPage,
        isFetched,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isError,
        status,
        error
    } = useInfiniteQuery({
        retry: false,
        refetchInterval: autoRefreshEnabled ? 1000 * 3 : false,
        refetchOnWindowFocus: true,
        queryKey,
        queryFn: ({ pageParam }) => {
            let params = { lastEvaluatedKey: pageParam };

            if (['invertedIndex', 'sparseIndex'].includes(selectedSearchOption?.value)) {
                params.indexName = selectedSearchOption?.value
            }

            if (decouncedSearchPkValue && selectedSearchOption?.value) {
                // params[selectedSearchOption?.value] = decouncedSearchValue;

                if (decouncedSearchSkValue) {
                    params.skKey = selectedSearchOption?.additional?.skKey
                    params.skValue = decouncedSearchSkValue
                }

                return fetchNotificationsJobRegistryTableItemsByPk({
                    ...params,
                    pkKey: selectedSearchOption?.additional?.pkKey,
                    pkValue: decouncedSearchPkValue
                })


            }

            return fetchNotificationsJobRegistryTableScan(params)
        },
        select: (data) => {
            return {
                pages: data.pages.map((page) => page.Items?.map(item => {
                    if (item.requestBody) {
                        try {
                            item.requestBodyParsed = JSON.parse(item.requestBody)
                        } catch (err) {
                            console.log(err)
                        }
                    }

                    if (item.startedAt && item.completedAt) {
                        const date1 = new Date(item.startedAt);
                        const date2 = new Date(item.completedAt);
                        item.duration = getTimeDiff({ date1, date2 })
                    }
                    return item
                })).flatMap((x) => x),
                pageParams: data.pageParams,
            };
            // return { ...data.hits, timestamp: Date.now() }
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.LastEvaluatedKey ? encodeURIComponent(JSON.stringify(lastPage.LastEvaluatedKey)) : null
        },
        staleTime: 0,//,Infinity,
        enabled: true  //&& !!showChat
    })

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchPkValue(event.target.value?.trim());
        }, 500),
        []
    );

    const debouncedSkChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchSkValue(event.target.value?.trim());
        }, 500),
        []
    );


    // const resutls = data?.pages.flat()
    const items = data?.pages.flat();

    let columns = ['pk', 'sk', 'createAt', 'startedAt', 'completedAt', 'updatedAt', 'status', 'duration', 'invokedBy', 'results.itemCounts', 'message'];

    if (showMoreColumns) {
        columns = [
            ...columns

        ];
    }

    const today = new Date();
    // today.setDate(today.getDate() + 1);

    return (
        <div className="container">
            {!subscriptionHccId &&
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                    <div>
                        <p className="title">Notification Job Registry Table</p>
                        <p className="sub-title">Search hints:   </p>
                        <p className="sub-title">pk: NEWAPPMESSAGE_NOTIFICATION_JOB | NOTIFICATION_PROCESSING_JOB -- sk: isotime </p>


                    </div>
                    <div>
                        <ToggleSwitch
                            label={`Auto Refresh`}
                            onToggle={(val) => setAutoRefreshEnabled(val)}
                            initialState={autoRefreshEnabled}
                        />
                    </div>

                </div>

            }


            {!subscriptionHccId && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    <Select
                        name={'searchOptions'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        options={searchOptions}
                        value={selectedSearchOption}
                        onChange={(option) => {
                            setSelectedSearchOption(option);
                            if (option.value === 'isFromIndex') {
                                setSearchPkValue('HRP');
                                setDecouncedSearchPkValue('HRP')
                            } else {
                                setSearchPkValue('');
                                setDecouncedSearchPkValue('');
                                setSearchSkValue('');
                                setDecouncedSearchSkValue('')
                            }
                        }}
                    />


                    {selectedSearchOption?.value && <> <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder={selectedSearchOption?.additional?.pkKey}
                        autoComplete="off"
                        onChange={(e) => {

                            setSearchPkValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchPkValue}
                    />
                        <input
                            style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                            type="text"
                            id={"sk"}
                            placeholder={selectedSearchOption?.additional?.skKey}
                            autoComplete="off"
                            onChange={(e) => {

                                setSearchSkValue(e.target.value);
                                debouncedSkChangeHandler(e);
                            }}
                            value={searchSkValue}
                        />
                    </>
                    }


                </div>
            </div>}


            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                {subscriptionHccId ? <p></p> : <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {

                        setSelectedSearchOption(null)
                        setSearchPkValue('');
                        setDecouncedSearchPkValue('');
                        setSearchSkValue('');
                        setDecouncedSearchSkValue('')
                    }}
                >
                    Clear filters
                </p>}

                <p style={{ cursor: "pointer", color: "var(--green)" }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                    {showMoreColumns ? "Less Columns" : "More Columns"}
                </p>
            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"notification-job-registry-table"}
                        columns={columns}
                        items={items}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}


        </div>
    )
}

export default NotificationsJobRegistry